(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('PlanningDetailOpenDialogService', PlanningDetailOpenDialogService);

    PlanningDetailOpenDialogService.$inject = ['$uibModal'];
    function PlanningDetailOpenDialogService ($uibModal) {
        var vm = null;

        return {
            setController: setController,
            editSoop:editSoop,
            updateObservationViaDialog:updateObservationViaDialog,
            updateEventViaDialog: updateEventViaDialog,
            manageUsers : manageUsers,
            doInsertPlanTemplateAtTime: doInsertPlanTemplateAtTime,
            doCreateSOOPFromTimeLine: doCreateSOOPFromTimeLine,
            doInsertSoopTemplateAtTime: doInsertSoopTemplateAtTime,
            doChangeMetisCompatibilityAtStartTime: doChangeMetisCompatibilityAtStartTime,
            moveSoop: moveSoop,
            moveObs: moveObs,
            moveEvents: moveEvents,
            addObservation: addObservation,
            addEvent: addEvent,
            insertPlan : insertPlan,
            setEfecsVersion : setEfecsVersion,
            insertSOCEvents: insertSOCEvents
        };

        function setController(Controller) {
            vm = Controller;
        }

        function editSoop(item) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/edit-soop-dialog.html',
                controller: 'EditSoopController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        soopInstanceId:  item.occurrence.soopInstanceId,
                        encodedSoopType: item.occurrence.encodedSoopType,
                        anchorDate : item.start,
                        soopType: item.occurrence.soopType,
                        planType: vm.planType,
                    }
                }
            });
        }

        function updateObservationViaDialog(observation, startDate, endDate, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-dialog.html',
                controller: 'PlanningDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                        action: 'Update',
                        cut: cut,
                        experiment: observation.experiment,
                        module: observation.module,
                        id: vm.planning.label,
                        start: startDate,
                        end: endDate,
                        observation: observation.name,
                        occurrence: observation,
                        locked: (vm.isLocked || vm.isVersion)
                    }

                }
            });
        }

        function updateEventViaDialog(occurrence, startDate, endDate, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-event-dialog.html',
                controller: 'PlanningEventDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        action: 'Update',
                        cut: cut,
                        id: vm.planning.label,
                        occurrence: occurrence,
                        startDate: startDate,
                        endDate: endDate,
                        locked: (vm.isLocked || vm.isVersion)
                    }

                }
            });
        }
        function manageUsers() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/manage-users.html',
                controller: 'ManageUsersController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                    }
                }
            });
        }
        function doInsertPlanTemplateAtTime(time) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/insert-template.html',
                controller: 'InsertTemplateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                        anchorTime: time,
                    }
                }
            });
        }

        function doCreateSOOPFromTimeLine(occurrences) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/create-soop-from-timeline.html',
                controller: 'CreateSOOPController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        planType: vm.planType,
                        obsDefLabel: vm.planning.observationDefinitions.label,
                        occurrences: occurrences
                    }
                }
            });
        }

        function setEfecsVersion() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/set-efecs-version.html',
                controller: 'SetEfecsVersionController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        label: vm.planning.label,
                        currentVersion: vm.planning.efecsVersion,
                        prime: vm.planning.prime,
                    }
                }
            });
        }

        function insertPlan() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/insert-plan.html',
                controller: 'InsertPlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        obsDefLabel: vm.planning.observationDefinitions.label,
                        label: vm.planning.label,
                        planType: vm.planType,
                        internalVersion: vm.planning.internalVersion
                    }
                }
            });
        }
        function insertSOCEvents() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/insert-soc-events-in-plan.html',
                controller: 'InsertSOCEventsPlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        obsDefLabel: vm.planning.observationDefinitions.label,
                        label: vm.planning.label,
                        planType: vm.planType,
                        internalVersion: vm.planning.internalVersion
                    }
                }
            });
        }
        function doInsertSoopTemplateAtTime(time) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/insert-soop-template.html',
                controller: 'InsertSoopTemplateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                        anchorTime: time,
                        obsDefLabel: vm.planning.observationDefinitions.label
                    }
                }
            });
        }
        function doChangeMetisCompatibilityAtStartTime(startTime, endTime) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/change-metis-compatibility.html',
                controller: 'ChangeMetisCompabilityController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        action: 'Update',
                        planType: vm.planType,
                        id: vm.planning.label,
                        startTime: startTime,
                        endTime: endTime,
                    }

                }
            });
        }

        function moveSoop(occurrence, newStartTime, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/move-soop.html',
                controller: 'MoveSoopController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        soopInstanceId:  occurrence.soopInstanceId,
                        encodedSoopType: occurrence.encodedSoopType,
                        soopType: occurrence.soopType,
                        anchorDate : newStartTime,
                        planType: vm.planType,
                        cut: cut
                    }
                }
            });
        }

        function moveObs(observations, newStartTime, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/move-obs.html',
                controller: 'MoveObsController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        anchorDate : newStartTime,
                        planType: vm.planType,
                        observations: observations,
                        cut: cut
                    }
                }
            });
        }

        function moveEvents(events, newStartTime, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/move-events.html',
                controller: 'MoveEventsController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        anchorDate : newStartTime,
                        planType: vm.planType,
                        events: events,
                        cut: cut
                    }
                }
            });
        }

        function addObservation(item) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-dialog.html',
                controller: 'PlanningDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                        action: 'Create',
                        group: item.group,
                        start: item.start,
                        version: vm.planning.version,
                        id: vm.planning.label,
                        locked: (vm.isLocked || vm.isVersion)
                    }
                }
            });
        }

        function addEvent(item) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-event-dialog.html',
                controller: 'PlanningEventDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        action: 'Create',
                        group: item.group,
                        start: item.start,
                        version: vm.planning.version,
                        id: vm.planning.label,
                        locked: (vm.isLocked || vm.isVersion)
                    }
                }
            });
        }


    }
})();
